var map = {
	"./gallery-1.jpg": 9076,
	"./gallery-10.jpg": 5478,
	"./gallery-11.jpg": 5587,
	"./gallery-12.jpg": 7780,
	"./gallery-13.jpg": 5825,
	"./gallery-2.jpg": 7203,
	"./gallery-3.jpg": 8678,
	"./gallery-4.jpg": 6477,
	"./gallery-5.jpg": 5552,
	"./gallery-6.jpg": 9887,
	"./gallery-7.jpg": 7218,
	"./gallery-8.jpg": 6489,
	"./gallery-9.jpg": 2140,
	"./product-1.jpg": 355,
	"./product-10.jpg": 9307,
	"./product-11.jpg": 1262,
	"./product-12.jpg": 8377,
	"./product-13.jpg": 7324,
	"./product-14.jpg": 3319,
	"./product-15.jpg": 7482,
	"./product-2.jpg": 2548,
	"./product-3.jpg": 593,
	"./product-4.jpg": 5106,
	"./product-5.jpg": 1135,
	"./product-6.jpg": 3872,
	"./product-7.jpg": 8653,
	"./product-8.jpg": 734,
	"./product-9.jpg": 2219,
	"./test-results.jpg": 2659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8337;